module.exports = __webpack_public_path__ + "img/articleThermalStab-Go-min.0af73769.png";